module.exports = __webpack_public_path__ + "static/media/football.8962c693.png";